import { useEffect, useRef, useState } from "react";

const DESKTOP = "(min-width: 1024px)";

export function useIsDesktop() {
  const [is, setIs] = useState(() => window.matchMedia(DESKTOP).matches);
  useEffect(() => {
    const mq = window.matchMedia(DESKTOP);
    const on = () => setIs(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return is;
}

/** One shared <audio> for voice / music previews; toggles play-pause per key. */
export function useAudioPreview() {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(null);
  useEffect(() => () => ref.current?.pause(), []);
  const stop = () => {
    ref.current?.pause();
    setPlaying(null);
  };
  const toggle = (key, url) => {
    if (!url) return;
    if (!ref.current) {
      ref.current = new Audio();
      ref.current.onended = () => setPlaying(null);
    }
    const a = ref.current;
    if (playing === key && !a.paused) return stop();
    a.src = url;
    a.play().then(() => setPlaying(key)).catch(() => setPlaying(null));
  };
  return { playing, toggle, stop };
}

export const fmtDur = (d) => (d ? `${Math.floor(d / 60)}:${String(Math.round(d % 60)).padStart(2, "0")}` : "");
